var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.44 14.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #996875;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.85,14.29c-.35,0-.7-.12-.97-.34L.57,9.59c-.65-.53-.74-1.48-.21-2.13s1.48-.74,2.13-.21l4.15,3.4L14.76.76c.53-.65,1.48-.74,2.13-.21.65.53.74,1.48.21,2.13l-9.07,11.06c-.24.29-.57.48-.94.54-.08.01-.16.02-.23.02Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.14,12.17c-1.42,0-2.78-.48-3.89-1.39l-1.7-1.39c-.65-.53-.74-1.48-.21-2.13.53-.64,1.48-.74,2.13-.21l1.7,1.39c.65.53,1.47.77,2.3.69.83-.09,1.58-.49,2.11-1.14L14.66.56c.53-.65,1.48-.74,2.13-.21s.74,1.48.21,2.13l-6.07,7.42c-1.03,1.28-2.51,2.08-4.15,2.25-.21.02-.43.03-.64.03Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/Tick.64b742ecf8b3ba6256f40e7141f74992.svg";
export { ForwardRef as ReactComponent };